import clsx from 'clsx'
import {RemoveAccents} from './RemoveAccents'
import * as component from '../components/redux/componentRedux'
import {useDispatch, useSelector} from 'react-redux'
import {step1DeleteContractById} from '../modules/insurance/healthInsurance/apis'
import {useEffect, useState} from 'react'
import {messageError} from './MessageError'
import DeleteIcon from '@mui/icons-material/Delete'
import {getObjFilters} from '../modules/insurance/InsuranceProducts/components/helper/createObjFilterContract'
import * as grid from '../redux-commons/GridRedux/gridRedux'
import {RootState} from '../../setup'
import {GridRenderEditCellParams} from '@mui/x-data-grid'
import { CustomModal } from '../../_metronic/partials/modals/CustomModal'
import { Button } from '@mui/material'

const useCallAPIDeleteContract = (sellingContractId: any, productCode: string) => {
  const [apiRes, setApiRes] = useState(false)
  const dispatch = useDispatch()
  const filterState = useSelector((state: RootState) => state.filter)?.FilterPersonInsurance

  const handleUpdateListContract = (productCode: string) => {
    let dataFilters = getObjFilters(filterState, 1, 20, productCode)
    switch (productCode) {
      case 'P_I':
        dispatch(grid.gridActions.getHealthDataGrid(dataFilters))
        break
      case 'AUTO_I':
        dispatch(grid.gridActions.getAutoDataGrid(dataFilters))
        break
      case 'MOTO_I':
        dispatch(grid.gridActions.getMotoDataGrid(dataFilters))
        break
      case 'CARGO_I':
        dispatch(grid.gridActions.getCargoDataGrid(dataFilters))
        break
      case 'SHIP_I':
        dispatch(grid.gridActions.getMarineDataGrid(dataFilters))
        break
      case 'PROPERTY_I':
        dispatch(grid.gridActions.getPropertyDataGrid(dataFilters))
        break
      default:
        break
    }
  }

  const requestDeleteContract = async () => {
    dispatch(component.actions.showBackdrop({show: true}))
    let alert = {
      show: true,
      type: '',
      message: '',
    }
    try {
      await step1DeleteContractById(sellingContractId)
      handleUpdateListContract(productCode)
      dispatch(component.actions.showBackdrop({show: false}))
      alert.type = 'success'
      alert.message = 'Xoá hợp đồng thành công.'
      dispatch(component.actions.writeAlert(alert))
      setApiRes(true)
    } catch (error: any) {
      dispatch(component.actions.showBackdrop({show: false}))
      alert.type = 'error'
      alert.message = messageError(error.response)
      dispatch(component.actions.writeAlert(alert))
    }
  }

  useEffect(() => {
    if (apiRes) {
      setApiRes(false)
    }
  }, [apiRes])

  return {requestDeleteContract, apiRes}
}

export const DeleteRow = (param: GridRenderEditCellParams) => {
  const [openModal, setOpenModal] = useState(false)
  const {requestDeleteContract, apiRes} = useCallAPIDeleteContract(
    param.row.id,
    param.row.productCode
  )

  const handleDeleteRow = () => {
    requestDeleteContract()
  }

  const ModalBtnConfirm = () => (
    <>
      <Button
        size='small'
        variant='outlined'
        className='modal-footer-btn custom-form-feature-btn'
        onClick={handleDeleteRow}
      >
        Xác nhận
      </Button>
    </>
  )
  return (
    <>
      <DeleteIcon onClick={() => setOpenModal(true)} color='action' />
      <CustomModal
        open={openModal}
        handleCloseModal={() => setOpenModal(false)}
        widthModal='60%'
        modalTitle='Xác nhận'
        ModalBtn={ModalBtnConfirm}
      >
        <div>Bạn có chắc chắn muốn xoá hợp đồng không?</div>
      </CustomModal>
    </>
  )
}

export const column = [
  {field: 'id', headerName: 'STT', minWidth: 30, maxWidth: 50, hide: true, sortable: false},
  {field: 'contractType', hide: true, headerName: 'STT', minWidth: 30, maxWidth: 50},
  {field: 'productCode', hide: true, headerName: 'STT', minWidth: 30, maxWidth: 50},
  {
    field: 'customerCode',
    headerName: 'code',
    minWidth: 30,
    maxWidth: 50,
    hide: true,
    sortable: false,
    align: 'center',
  },
  {
    field: 'customerVersion',
    headerName: 'version',
    minWidth: 30,
    maxWidth: 50,
    hide: true,
    sortable: false,
  },
  {
    field: 'groupDomainCode',
    headerName: 'version',
    minWidth: 30,
    maxWidth: 50,
    hide: true,
    sortable: false,
  },
  {
    field: 'createdDate',
    headerName: 'Ngày tạo',
    minWidth: 110,
    maxWidth: 150,
    headerAlign: 'center',
    sortable: false,
    align: 'center',
  },
  {
    field: 'quatationNumber',
    headerName: 'Số chào phí',
    minWidth: 150,
    maxWidth: 300,
    flex: 1,
    sortable: false,
    headerAlign: 'center',
    align: 'left',
  },
  {
    field: 'customerName',
    headerName: 'Tên khách hàng',
    headerAlign: 'center',
    minWidth: 400,
    flex: 1,
    sortable: false,
  },

  {
    field: 'companyNameMaster',
    headerName: 'Tên công ty Master',
    width: 200,
    maxWidth: 300,
    sortable: false,
    headerAlign: 'center',
    align: 'left',
  },
  {
    field: 'originalNumber',
    headerName: 'Số hợp đồng Master',
    minWidth: 150,
    maxWidth: 300,
    flex: 1,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'contractNumber',
    headerName: 'Số hợp đồng',
    minWidth: 250,
    maxWidth: 400,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'PIC',
    headerName: 'Người xử lý',
    minWidth: 250,
    maxWidth: 400,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  // {
  //   field: 'purchaseDate',
  //   headerName: 'Ngày cấp',
  //   minWidth: 120,
  //   maxWidth: 200,
  //   sortable: false,
  //   headerAlign: 'center',
  //   align: 'center',
  // },
  {
    field: 'startDate',
    headerName: 'Ngày hiệu lực',
    minWidth: 120,
    maxWidth: 200,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'expireDate',
    headerName: 'Ngày kết thúc',
    minWidth: 120,
    maxWidth: 200,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'sumFeeName',
    headerName: 'Tổng phí',
    headerAlign: 'center',
    minWidth: 100,
    maxWidth: 200,
    sortable: false,
    align: 'right',
  },
  {
    field: 'statusName',
    headerName: 'Trạng thái',
    minWidth: 170,
    maxWidth: 250,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params: any) => (
      <p
        className={clsx(`fs-8 fw-bolder`, {
          'badge-light-danger':
            params.value.toLowerCase().includes('từ chối') ||
            RemoveAccents(params.value).toLowerCase().includes('huy') ||
            params.value.toLowerCase().includes('chấm dứt'),
          'badge-light-warning': params.value.toLowerCase().includes('vượt'),
          'badge-light-success':
            params.value.toLowerCase().includes('thành công') ||
            params.value.toLowerCase().includes('duyệt') ||
            params.value.toLowerCase().includes('hoàn thành') ||
            params.value.toLowerCase().includes('ký số') ||
            params.value.toLowerCase().includes('đồng ý') ||
            params.value.toLowerCase().includes('đã ký'),
          'badge-light-primary':
            params.value.toLowerCase().includes('thông tin') ||
            params.value.toLowerCase().includes('chương trình') ||
            params.value.toLowerCase().includes('đang') ||
            params.value.toLowerCase().includes('nhập') ||
            params.value.toLowerCase().includes('tạo') ||
            params.value.toLowerCase().includes('trình') ||
            params.value.toLowerCase().includes('báo'),
        })}
        style={{backgroundColor: 'transparent'}}
      >
        {params.value}
      </p>
    ),
  },
  {
    field: 'paymentGatewayTypeName',
    headerName: 'Cổng thanh toán',
    minWidth: 130,
    maxWidth: 200,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'paymentTypeName',
    headerName: 'Kiểu thanh toán',
    minWidth: 150,
    maxWidth: 200,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'agent',
    headerName: 'Đại lý',
    minWidth: 180,
    maxWidth: 200,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'divisionName',
    headerName: 'Đơn vị',
    minWidth: 150,
    maxWidth: 200,
    flex: 1,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'contractKindName',
    headerName: 'Kiểu hợp đồng',
    minWidth: 220,
    maxWidth: 250,
    flex: 1,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'contractTypeName',
    headerName: 'Loại hợp đồng',
    minWidth: 120,
    maxWidth: 150,
    flex: 1,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'groupDomainName',
    headerName: 'Sản phẩm bảo hiểm',
    minWidth: 150,
    maxWidth: 200,
    flex: 1,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'source',
    headerName: 'Nguồn hợp đồng',
    minWidth: 140,
    maxWidth: 200,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'managerName',
    headerName: 'Người quản lý',
    minWidth: 150,
    maxWidth: 200,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'userCreatedName',
    headerName: 'Người tạo',
    minWidth: 150,
    maxWidth: 200,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    field: 'partnerName',
    headerName: 'Đối tác',
    minWidth: 180,
    maxWidth: 200,
    flex: 1,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'action',
    headerName: 'Hành động',
    headerAlign: 'center',
    sortable: false,
    align: 'center',
    renderCell: (params: GridRenderEditCellParams) => <DeleteRow {...params} />,
  },
]
